export const MAX_USER_NAME_LENGHT = 20

export const EMOJI_REGEXP = /[\p{Emoji}]/u
export const INTEGER_REGEXP = /^\d+$/
export const PRICE_REGEXP = /^-?\d*(\.\d{1,4})?$/
export const PRICE_PATTERN = '/^d*.?d{0,4}$/'
